export default {
    "profile": "प्रोफाइल",
    "logout": "बाहिर निस्कनु",
    "dashboard": "ड्यासबोर्ड",
    "password": "पासवर्ड",
    "language": "भाषा",
    "paymentbr": "भुक्तानी",
    "subscriptionPaymentMethod": "सदस्यता र भुक्तानी विधि",
    "nothingchanged": "केही परिवर्तन भएको छैन",
    "somethingWentWrong": "केहि गलत भयो ! कृपया पछि पुन: प्रयास गर्नुहोस्",
    "pleaseTryAgainAfterSometime": "कृपया केहि समय पछि पुन: प्रयास गर्नुहोस्",
    "noChanges": "परिवर्तन भएको छैन",
    "invalidEmailFormat": "इमेल ढाँचा अमान्य छ",
    "chooseYourPreferredLanguage": "कृपया आफ्नो मनपर्ने भाषा छान्नुहोस्।",
    "selectLanguage": "भाषा छनोट गर्नुस",
    "update": "अपडेट गर्नुहोस्",
    "languagePreferences": "भाषा प्राथमिकताहरू",
    "packageOf": "को प्याकेज",
    "satelliteReport": "उपग्रह रिपोर्टहरू",
    "pastureReport": "चरन रिपोर्टहरू",
    "upTo": "सम्म",
    "animals": "जनावरहरू",
    "back": "पछाडि",
    "perMonth": "प्रति महिना",
    "perYear": "प्रति वर्ष",
    "continue": "जारी राख्नुहोस्",
    "changePlan": "योजना परिवर्तन गर्नुहोस्",
    "addOn": "यसमा थप्नुहोस्",
    "totalPrice": "कुल रकम",
    "availableAddOns": "उपलब्ध एड-अनहरू",
    "next": "अर्को",
    "congratulations": "बधाई छ",
    "done": "भयो",
    "deforestationComplianceAssessment": "वन विनाश अनुपालन मूल्याङ्कन",
    "warning": "चेतावनी",
    "yourDataMightLost": "तपाईंको डाटा हराउन सक्छ।",
    "clickOnSaveBtnMsg": "आफ्नो डाटा सुरक्षित गर्न बचत बटन क्लिक गर्नुहोस्",
    "discardChanges": "परिवर्तनहरू खारेज गर्नुहोस्",
    "action": "कार्यहरू",
    "sendRequest": "अनुरोध पठाउने",
    "success": "सफलता",
    "yourRequestSuccessfullySubmitted": "तपाईंको अनुरोध सफलतापूर्वक पेस गरियो।",
    "informShortly": "तपाईंको अनुरोध सफलतापूर्वक पेश गरिएको छ। तपाईको विश्लेषण रिपोर्ट छिट्टै तपाईलाई पठाइनेछ।",
    "search": "खोज्नुहोस्",
    "pending": "विचाराधीन",
    "approved": "स्वीकृत",
    "rejected": "अस्वीकार गरियो",
    "primaryGeofence": "प्राइमरी जियोफेन्स",
    "Zero/Negligible Deforestation Probability": "शून्य/नगण्य वन नाशको सम्भावना",
    "Low Deforestation Probability": "कम वन नाशको सम्भावना",
    "High Deforestation Probability": "उच्च वन नाशको सम्भावना",
    "login": {
        "welcome": "स्वागत छ! लग - इन",
        "welInfo": "आफ्नो प्रमाणहरू प्रविष्ट गर्नुहोस्।",
        "login": "लग - इन",
        "emailMobile": "इमेल/मोबाइल",
        "forgotPassword": "पासवर्ड भुल्नु भयो",
        "register": "दर्ता गर्नुहोस्",
        "unableToLogin": "लगइन गर्न असमर्थ",
        "emailMobileCannotEmpty": "इमेल/मोबाइल खाली हुन सक्दैन।",
        "invalidEmailMobileFormat": "अवैध इमेल/मोबाइल ढाँचा।",
        "passwordCannotEmpty": "पासवर्ड खाली हुन सक्दैन।",
        "passwordLengthCanlessthan8": "पासवर्ड लम्बाइ 8 वर्ण भन्दा कम हुनु हुँदैन।",
        "email": "इमेल",
        "phone": "फोन",
        "or": "वा",
        "alreadyHaveAccount": "पहिले नै खाता छ",
        "loginNow": "अहिले लगइन गर्नुहोस्",
        "registerOption": "साइन अप गर्न विकल्प छान्नुहोस्",
        "signUpWith": "साथ साइन अप गर्नुहोस्"
    },
    "user": {
        "profileUpdated": "प्रोफाइल सफलतापूर्वक अद्यावधिक गरिएको छ",
        "profileNotUpdated": "प्रोफाइल अपडेट गरिएको छैन",
        "otpSentOnEmail": "OTP सफलतापूर्वक पठाइयो!",
        "otpSentSuccessFully": "तपाईंको OTP कोड पठाइयो",
        "unableToVerifyEmail": "इमेल प्रमाणित गर्न असमर्थ",
        "emailCanNotBeEmpty": "इमेल फिल्डहरू खाली गर्न सकिँदैन",
        "firstName": "पहिलो नाम",
        "lastName": "थर",
        "email": "इमेल",
        "mobile": "मोबाइल",
        "currentPassword": "वर्तमान पासवर्ड",
        "newPassword": "नया पासवर्ड",
        "repeatNewPassword": "नयाँ पासवर्ड दोहोर्याउनुहोस्",
        "firstNameRequired": "पहिलो नाम आवश्यक छ।",
        "lastNameRequired": "थर आवश्यक छ",
        "emailRequired": "इमेल आवश्यक छ",
        "onlyAlphabet": "अक्षरहरू मात्र समावेश गर्न सकिन्छ",
        "notMoreThan15Char": "15 वर्ण भन्दा बढी हुन सक्दैन",
        "phoneCannotLessThan8Char": "फोन 8 वर्ण भन्दा कम हुन सक्दैन",
        "countryCodeRequire": "देशको कोड आवश्यक छ",
        "changePassword": "पासवर्ड परिवर्तन गर्नुहोस्",
        "goodIdeaToUsePassword": "तपाईंले अन्यत्र प्रयोग नगरेको बलियो पासवर्ड प्रयोग गर्नु राम्रो विचार हो।",
        "enterCurrentPassword": "हालको पासवर्ड प्रविष्ट गर्नुहोस्",
        "enterNewPassword": "नयाँ पासवर्ड प्रविष्ट गर्नुहोस्",
        "reEnterPassword": "पासवर्ड पुन: प्रविष्टि गर्नुहोस्",
        "pleaseTypeOldPassword": "कृपया पुरानो पासवर्ड टाइप गर्नुहोस्।",
        "pleaseTypeNewPassword": "कृपया नयाँ पासवर्ड टाइप गर्नुहोस्।",
        "pleaseTypeConfirmPassword": "कृपया पुष्टि पासवर्ड टाइप गर्नुहोस्।",
        "passwordChangedSuccesFully": "पासवर्ड सफलतापूर्वक परिवर्तन भयो",
        "passwordDoesNotMatch": "पासवर्डहरू मेल खाँदैन।",
        "passwordRequired": "पासवर्ड आवश्यक छ",
        "emailOrPhoneIsRequired": "इमेल वा फोन नम्बर आवश्यक छ"
    },
    "subscription": {
        "subscription": "सदस्यता",
        "membershipPlan": "सदस्यता योजनाहरू",
        "currentMembershipPlan": "हालको सदस्यता योजना",
        "validUpTo": "सम्म मान्य",
        "viewAllAddOns": "सबै एड-अनहरू हेर्नुहोस्",
        "renewValidity": "वैधता नवीकरण गर्नुहोस्",
        "buyNow": "अहिले खरिद गर",
        "upgradeMembershipPlan": "सदस्यता योजना अपग्रेड गर्नुहोस्",
        "chooseYourMembershipPlan": "तपाईंले रोजेको सदस्यता योजना",
        "chooseOptionalAddOns": "तपाईं वैकल्पिक Add-ons छनोट गर्न सक्नुहुन्छ",
        "yourSelectedAddons": "तपाईंको चयन गरिएका एड-अनहरू",
        "addAnotherAddOn": "अर्को एड-अन थप्नुहोस्",
        "paymentMethod": "भुक्तानी विधि",
        "addingAPaymentMethod": "भुक्तानी विधि थप्दै",
        "paymentSuccessful": "तपाईंको भुक्तानी सफल भयो!",
        "weHaveEmailed": "हामीले तपाईंको प्राप्तिको प्रतिलिपि example@email.com मा इमेल गरेका छौं",
        "paymentAuthorizedSuccessfully": "भुक्तानी सफलतापूर्वक अधिकृत गरियो।",
        "paymentSuccessfulPrompt": "भुक्तानी सफल भयो। योजना अपग्रेड गरियो।",
        "paymentCancelled": "भुक्तानी रद्द गरियो। फेरि प्रयास गर्नुहोस।"
    },
    "registerFarm": "फार्म दर्ता गर्नुहोस्",
    "requestDeforestationReport": "वन विनाश रिपोर्ट अनुरोध गर्नुहोस्",
    "paymentMenu": "भुक्तानी",
    "complianceCertificate": "अनुपालन प्रमाणपत्र",
    "helpDisk": "मद्दत डिस्क",
    "faqs": "FAQ को",
    "enquiries": "सोधपुछ",
    "contactUs": "हामीलाई सम्पर्क गर्नुहोस",
    "payment": {
        "basicPlan": "आधारभूत योजना",
        "advancePlan": "अग्रिम योजना",
        "usdPerMonthPlus": "USD प्रति महिना प्लस",
        "perReport": "प्रति रिपोर्ट",
        "deforestationAnalyticsCertificateDownload": "वन विनाश विश्लेषण प्रमाणपत्र डाउनलोड"
    },
    "farm": {
        "farmOwnershipType": "फार्म स्वामित्वको प्रकार",
        "licenceNum": "लाइसेन्स नम्बर",
        "viewFarm": "फार्म हेर्नुहोस्",
        "stateProvince": "प्रदेश/प्रदेश",
        "postalNumberShouldSimilarToFarm": "घरको नम्बर जस्तै फार्मको हुलाक नम्बर।",
        "videoTutorial": "भिडियो ट्यूटोरियल",
        "clickOnMapMSG": "जियोफेन्सिङ सुरु गर्न नक्सामा क्लिक गर्नुहोस्",
        "prev": "अघिल्लो",
        "next": "अर्को",
        "dragVertexMsg": "तपाईं पनि ठाडो तान्नुहोस्, वा दायाँ छेउमा मेट्नुहोस् बटन प्रयोग गरेर तिनीहरूलाई मेटाउन सक्नुहुन्छ। जियोफेन्स पनि क्लियर बटन प्रयोग गरेर खाली गर्न सकिन्छ",
        "farmAddedSuccessfully": "खेत सफलतापूर्वक थपियो",
        "perimeter": "परिधि",
        "area": "क्षेत्र",
        "clearGeofence": "खाली Geofence",
        "deleteSelectedVertex": "चयन गरिएको भेर्टेक्स मेटाउनुहोस्",
        "pleaseStartDrawing": "कृपया नक्सामा जियोफेन्स चित्रण सुरु गर्नुहोस्।",
        "chooseTheDate": "मिति छान्नुहोस्",
        "updateGeofenceForThisFarm": "यस फार्मको लागि GEOFENCE अद्यावधिक गर्नुहोस्",
        "farmUpdateSuccessfully": "खेत सफलतापूर्वक अपडेट गरियो",
        "farmZone": "फार्म क्षेत्रहरू",
        "addNewZones": "नयाँ क्षेत्रहरू थप्नुहोस्",
        "zoneName": "क्षेत्रको नाम",
        "addZoneToCreate": "यो फार्मको लागि जोन बनाउनको लागि कृपया Add Zones मा क्लिक गर्नुहोस्।",
        "noZoneCreated": "अहिलेसम्म कुनै पनि जोन बनेका छैनन् ।",
        "searchAndAddPin": "खोज्नुहोस् र पिन थप्नुहोस्",
        "zoneNameWillBeHere": "क्षेत्रको नाम यहाँ हुनेछ",
        "editZone": "क्षेत्र सम्पादन गर्नुहोस्",
        "nameOfTheField": "फिल्डको नाम",
        "zoneDetails": "क्षेत्र विवरण",
        "addZone": "क्षेत्र थप्नुहोस्",
        "nameOfTheZone": "क्षेत्रको नाम",
        "geofenceIsRequiredToAdd": "क्षेत्र थप्न जियोफेन्स आवश्यक छ। तपाईंको फार्ममा जियोफेन्स विवरणहरू थप्नको लागि `फार्म सम्पादन गर्नुहोस्` क्लिक गर्नुहोस्।",
        "thisFieldApplyHelpText": "यो क्षेत्र तपाईलाई मात्र लागू हुन्छ यदि तपाई कुनै सहकारीसँग हुनुहुन्छ (सहकारी भनेको संयुक्त स्वामित्वमा रहेको र लोकतान्त्रिक रूपमा नियन्त्रित उद्यम मार्फत उनीहरूको साझा आर्थिक, सामाजिक र सांस्कृतिक आवश्यकता र आकांक्षाहरू पूरा गर्न स्वेच्छिक रूपमा एकजुट भएका व्यक्तिहरूको स्वायत्त संस्था हो)। यदि तपाईं सहकारीमा हुनुहुन्छ भने, कृपया त्यस सहकारीको अद्वितीय पहिचानकर्तालाई संकेत गर्नुहोस्, यो एक दर्ता वा इजाजतपत्र नम्बर हुन सक्छ जुन तपाईंले सम्बद्ध सहकारीलाई अद्वितीय रूपमा पहिचान गर्न सक्नुहुन्छ।",
        "farmRegistrationID": "फार्म दर्ता आईडी",
        "farmerName": "किसानको नाम",
        "farmerRegistrationID": "किसान दर्ता आईडी",
        "dateOfRequest": "अनुरोध मिति",
        "status": "स्थिति",
        "address": "ठेगाना",
        "save": "बचत गर्नुहोस्",
        "farmAddress": "फार्म स्थान ठेगाना",
        "corporateName": "कर्पोरेट नाम",
        "corporateMailingAddress": "कर्पोरेट पत्राचार ठेगाना",
        "farmID": "फार्म आईडी",
        "onTheFarm": "खेतमा",
        "userRoles": "प्रयोगकर्ता भूमिकाहरू",
        "adduser": "प्रयोगकर्ता थप्नुहोस्",
        "addAuser": "प्रयोगकर्ता थप्नुहोस्",
        "uploadUsers": "प्रयोगकर्ताहरू अपलोड गर्नुहोस्",
        "addNewUser": "नयाँ प्रयोगकर्ता थप्नुहोस्",
        "selectDept": "विभाग छान्नुहोस्",
        "selectRole": "भूमिका चयन गर्नुहोस्",
        "editUser": "प्रयोगकर्ता सम्पादन गर्नुहोस्",
        "totalFarms": "कुल फार्महरू",
        "NoAnimalsRegisteredForthisFarm": "यस फार्मको लागि कुनै पनि जनावर दर्ता गरिएको छैन",
        "farmsPerPage": "प्रति पृष्ठ फार्महरू",
        "regularFarms": "नियमित फार्महरू",
        "farmRegisteredProducts": "फार्म दर्ता उत्पादनहरू",
        "searchByFarmNameAndId": "फार्मको नाम र आईडी द्वारा खोज्नुहोस्",
        "loadingProductsPleaseWait": "उत्पादनहरू लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
        "farmName": "खेतको नाम",
        "farmLocation": "फार्म स्थान",
        "productName": "उत्पादनको नाम",
        "stockStatus": "स्टक स्थिति",
        "inStock": "स्टक मा",
        "searchByProductName": "उत्पादन नाम द्वारा खोज",
        "productCategory": "उत्पादन कोटि",
        "products": "उत्पादनहरू",
        "yourLocationIsDisabled": "तपाईंको स्थान असक्षम गरिएको छ। कृपया बायाँ मेनुबाट आफ्नो स्थान खोज्नुहोस्।",
        "close": "बन्द गर्नुहोस्",
        "farms": "खेतहरू",
        "zones": "क्षेत्रहरू",
        "registerAfarm": "फार्म दर्ता गर्नुहोस्",
        "govtRegistry": "सरकार रजिस्ट्री",
        "cooperativeID": "सहकारी/संघ आईडी",
        "cooperativeName": "सहकारी/संघको नाम",
        "farmType": "फार्म प्रकार",
        "contractMating": "अनुबंध मिलन",
        "customization": "अनुकूलन",
        "recordsPerpage": "प्रति पृष्ठ रेकर्डहरू",
        "restoreDefault": "पूर्वनिर्धारित पुनर्स्थापना",
        "apply": "निवेदन गर्नु",
        "CommunityName": "समुदायको नाम",
        "searchState": "फार्म आईडी, गभर्नर रजिस्ट्री, सहकारी आईडी, फार्म प्रकार, अनुबंध मिलन द्वारा खोज्नुहोस्",
        "farmOwner": "खेत मालिक",
        "govRegistrationNo": "सरकारी दर्ता नम्बर",
        "farmInformation": "फार्म जानकारी",
        "ownershipType": "स्वामित्वको प्रकार",
        "farmLicenseInformation": "फार्म लाइसेन्स जानकारी",
        "licenseNumber": "लाइसेन्स नम्बर",
        "licenseExpiryDate": "इजाजतपत्र समाप्ति मिति",
        "regulatorName": "नियामक नाम",
        "regulatorRepresentativeName": "नियामक प्रतिनिधि नाम",
        "farmLocationSize": "फार्म स्थान र आकार",
        "productionSystem": "खेती प्रणाली",
        "country": "देश",
        "state": "राज्य",
        "city": "गाउँ/नगर/शहर",
        "farmNumber": "फार्म नम्बर",
        "postal": "हुलाक / जिप कोड",
        "houseNumber": "घर नम्बर",
        "farmRegistration": "फार्म दर्ता",
        "cancel": "रद्द गर्नुहोस्",
        "register": "दर्ता गर्नुहोस्",
        "ok": "ठिक छ",
        "totalFarmSize": "कुल फार्म आकार",
        "geographicLocation": "भौगोलिक स्थान",
        "farmGeographicLocation": "खेत भौगोलिक स्थान",
        "perimeterPointLongitude": "परिधि बिन्दु देशान्तर",
        "perimeterPointLatitude": "परिधि बिन्दु अक्षांश",
        "perimeterPointLabel": "परिधि बिन्दु लेबल",
        "perimeterLength": "परिधि लम्बाइ",
        "farmLatitude": "फार्म अक्षांश",
        "farmLongitude": "खेत देशान्तर",
        "latitude": "अक्षांश",
        "longitude": "देशान्तर",
        "areaUnit": "क्षेत्र एकाइ",
        "walkAndMeasure": "हिंड्नुहोस् र मापन गर्नुहोस्",
        "useGeofenceTool": "जियोफेन्स उपकरण प्रयोग गर्नुहोस्",
        "editFarm": "खेत सम्पादन गर्नुहोस्",
        "update": "अपडेट गर्नुहोस्",
        "editAfarm": "खेत सम्पादन गर्नुहोस्",
        "nextFarm": "अर्को खेत",
        "nameoftheFarm": "फार्मको नाम",
        "registerAProduct": " उत्पादन दर्ता गर्नुहोस्",
        "farmProducts": "कृषि उत्पादनहरू",
        "calf": "बाछो",
        "steer": "स्टियर",
        "heifer": "हेफर",
        "sire": "हजुर",
        "dam": "बाँध",
        "registerAnAnimal": "एक जनावर दर्ता गर्नुहोस्",
        "farmAnimals": "फार्म पशुहरू",
        "farm_type": "फार्म-प्रकार",
        "farm_Owner": "खेत-मालिक",
        "dateOfRegistration": "दर्ता मिति",
        "dataIsNotAvailableForThisFarm": "यस फार्मको लागि डाटा उपलब्ध छैन",
        "registerNewProduct": "नयाँ उत्पादन दर्ता गर्नुहोस्",
        "information": "जानकारी",
        "licenseInfo": "लाइसेन्स जानकारी",
        "locationInfo": "स्थान जानकारी",
        "geoLocation": "भौगोलिक स्थान",
        "perimeterLengthState": "खेत परिधिको लम्बाइ (बार लम्बाइ)",
        "totalFarmSizeState": "फार्म को आकार",
        "productionSystemState": "खेतमा प्रयोग हुने उत्पादन प्रणाली",
        "contractMatingState": "फर्मले भाग लिने अनुबन्ध मिलन कार्यक्रमको संहिता।",
        "ownershipTypeState": "स्वामित्वको प्रकार",
        "regulatorRepresentativeNameState": "इजाजतपत्र जारी गर्ने नियामकको प्रतिनिधित्व गर्ने व्यक्तिको नाम",
        "regulatorNameState": "इजाजतपत्र जारी गर्ने नियामकको नाम",
        "licenseExpiryDateState": "हालको इजाजतपत्रको म्याद सकिएको मिति",
        "licenseNumberState": "नियामकले जारी गरेको इजाजतपत्र नम्बर",
        "plotNumberState": "खेतको घर नम्बर।",
        "plotNumber": "फार्म नम्बर",
        "streetStatement": "खेतको सडकको नाम।",
        "cityStatement": "सहर जहाँ फार्म अवस्थित छ।",
        "stateStatement": "देशको क्षेत्र जहाँ फार्म अवस्थित छ।",
        "countryState": "देश जहाँ फार्म अवस्थित छ।",
        "farmStateInfo": "खेत स्थान ठेगाना",
        "perimeterPointLongitudeState": "खेतमा एक बिन्दुको देशान्तर।",
        "perimeterPointLatitudeState": "खेतमा एक बिन्दुको अक्षांश।",
        "perimeterPointLabelState": "बिन्दुको लेबल।",
        "farmLongitudeState": "खेत को देशान्तर।",
        "farmLatitudeState": "खेतको अक्षांश।",
        "deleteFarm": "फार्म मेटाउनुहोस्",
        "corporateRegistrationNum": "कर्पोरेट दर्ता नम्बर",
        "farmLocationIsRequired": "फार्म स्थान आवश्यक छ।"
    },
    "deforestation": {
        "addZoneToThisFarm": "यस फार्ममा क्षेत्रहरू थप्नुहोस्",
        "eudrForestAssessment": "EUDR वन मूल्याङ्कन",
        "requestEudrForestAssessment": "EUDR वन मूल्याङ्कन अनुरोध गर्नुहोस्",
        "pleaseChooseOption": "कृपया विकल्प छान्नुहोस्",
        "requestForestReport": "वन रिपोर्ट अनुरोध गर्नुहोस्",
        "noDeforestationReportMsg": "कुनै वन विनाश रिपोर्ट अनुरोध गरिएको छैन। कृपया केही वन विनाश रिपोर्टहरू यहाँ सूचीबद्ध गर्न अनुरोध गर्नुहोस्।",
        "allCountries": "सबै देशहरू",
        "allRegions": "सबै क्षेत्रहरू",
        "allFarms": "सबै फार्महरू",
        "allStatus": "सबै स्थिति",
        "viewCertificate": "प्रमाणपत्र हेर्नुहोस्",
        "requestComplianceCertificate": "अनुरोध अनुपालन प्रमाणपत्र",
        "assessmentNo": "मूल्याङ्कन नं",
        "blockchainCertificationInfo": "Blockchain प्रमाणपत्र प्रमाणीकरण ह्यास प्रमाणपत्र को स्वीकृति मा उपलब्ध हुनेछ",
        "blockchainCertificationValidation": "Blockchain प्रमाणपत्र प्रमाणीकरण",
        "openBlockchainPage": "Blockchain पृष्ठ खोल्नुहोस्",
        "clickOnAboveLink": "ब्लकचेनमा प्रमाणपत्र प्रमाणित गर्न माथिको लिङ्कमा क्लिक गर्नुहोस्",
        "shareCertificate": "सेयर सर्टिफिकेट",
        "high": "उच्च",
        "low": "कम",
        "zeroOrNegigible": "शून्य वा नगण्य",
        "deforestationProbability": "वन विनाशको सम्भावना",
        "colorCode": "रङ कोड",
        "geofenceAarea": "Geofence क्षेत्र",
        "percentageOfGeofenceArea": "Geofence क्षेत्र को प्रतिशत",
        "overallDeforestationProbability": "समग्र वन विनाश सम्भाव्यता",
        "deforestationComplianceReport": "वन विनाश अनुपालन रिपोर्टहरू",
        "noDeforestationComplianceReport": "कुनै वन विनाश अनुपालन eReport फेला परेन",
        "loadingDeforestationComplianceReport": "वन विनाश अनुपालन ई-रिपोर्ट लोड गर्दै",
        "farmRegistrationId": "फार्म दर्ता आईडी",
        "farmerName": "किसानको नाम",
        "farmerRegistrationId": "किसान दर्ता आईडी",
        "uniqueFarmerId": "अद्वितीय किसान आईडी",
        "uniqueFarmId": "अद्वितीय फार्म आईडी",
        "farmLocation": "फार्म स्थान",
        "area": "क्षेत्र",
        "farmAddress": "फार्म ठेगाना",
        "dateOfRequest": "अनुरोध मिति",
        "status": "स्थिति",
        "settings": "सेटिङहरू",
        "assignmentIssued": "असाइनमेन्ट जारी गरियो",
        "certificateIssued": "प्रमाणपत्र जारी गरियो",
        "complianceCertification": "अनुपालन प्रमाणीकरण",
        "noComplianceCertification": "कुनै अनुपालन प्रमाणीकरण फेला परेन",
        "loadingComplianceCertification": "अनुपालन प्रमाणीकरण लोड गर्दै",
        "assessmentReport": "मूल्याङ्कन प्रतिवेदन",
        "downloadPDF": "PDF डाउनलोड गर्नुहोस्",
        "print": "छाप्नुहोस्",
        "back": "पछाडि",
        "farmDetails": "फार्म विवरण",
        "dimitraFarmId": "दिमित्रा फार्म आईडी",
        "dimitraFermerId": "दिमित्रा किसान आईडी",
        "totalGeofenceAreaHA": "कुल जियोफेन्स क्षेत्र (HA)",
        "forestLossHA": "वन हानि (HA)",
        "forestGainHA": "वन लाभ (HA)",
        "forestUnchangedHA": "वन अपरिवर्तित (HA)",
        "forestUnchanged": "वन अपरिवर्तित",
        "forestLoss": "वन हानि",
        "forestGain": "वन लाभ",
        "totalGeofenceArea": "कुल Geofence क्षेत्र",
        "forestAssessmentHelp": "यदि तपाइँसँग यस रिपोर्टको बारेमा प्रश्नहरू छन् वा यसलाई बुझ्न मद्दत चाहिन्छ भने, मद्दत डेस्क मार्फत हामीलाई सम्पर्क गर्नुहोस्।",
        "allReport": "सबै रिपोर्टहरू",
        "deforestationRepot": "वन विनाश रिपोर्ट",
        "requestDeforestationReportNow": "अब वन विनाश रिपोर्ट अनुरोध गर्नुहोस्",
        "noRecordFound": "कुनै रेकर्ड फेला परेन",
        "noDeforestationReportRequested": "कुनै वन विनाश रिपोर्ट अनुरोध गरिएको छैन। कृपया केही वन विनाश रिपोर्टहरू यहाँ सूचीबद्ध गर्न अनुरोध गर्नुहोस्।",
        "deforestationImage": "वन विनाश छवि",
        "reqDeforestationReport": "वन विनाश रिपोर्ट अनुरोध गर्नुहोस्",
        "confirm": "पुष्टि गर्नुहोस्",
        "newForestArea": "नयाँ वन क्षेत्र",
        "deforestedArea": "वन विनाश क्षेत्र",
        "existingForestArea": "अवस्थित वन क्षेत्र",
        "deforestation": "वन विनाश",
        "farmName": "खेतको नाम",
        "location": "स्थान",
        "dateOfInterest": "ब्याज मिति",
        "geofenceArea": "GeofenceArea (HA)",
        "deforestationArea": "वन विनाश क्षेत्र (HA)",
        "treeGainArea": "रूख लाभ क्षेत्र (HA)",
        "currentForestArea": "हालको वन क्षेत्र (HA)",
        "view": "हेर्नुहोस्",
        "locationInfoRequired": "स्थान जानकारी आवश्यक छ",
        "geofenceNameRequired": "Geofence नाम आवश्यक छ",
        "futureDateSelected": "भविष्यको मिति चयन गरियो",
        "reportGeneratedSuccessfully": "रिपोर्ट सफलतापूर्वक उत्पन्न भयो",
        "reportCannotAdded": "रिपोर्ट थप्न सकिँदैन।",
        "primaryFarmNotFound": "प्राथमिक फार्म फेला परेन।",
        "pleaseRegisterFarmFirst": "कृपया पहिले फार्म दर्ता गर्नुहोस्",
        "tooltip": {
            "dimitraFarmId": "डिमिट्रा प्रणालीमा एक विशेष खेतसंग जडित एकल पहिचानकर्ता।",
            "farmName": "खेतको नियुक्त नाम।",
            "farmRegistrationId": "खेतको दर्ता नम्बर।",
            "farmLocation": "खेतको विशेष भौगोलिक निर्देशाङ्कहरू वा स्थान।",
            "dimitraFarmerId": "डिमिट्रा प्रणालीमा एक विशेष किसानसँग जडित विशेष पहिचानकर्ता।",
            "farmerName": "खेतको लागि जिम्मेदार व्यक्तिको पहिचान।",
            "farmerRegistrationId": "किसानको दर्ता नम्बर।",
            "assessmentNo": "मूल्याङ्कनको लागि निर्धारित गरिएको एक अनौपचारिक नम्बर।"
          }
    },
    "certificate": {
        "allCertificate": "सबै प्रमाणपत्रहरू",
        "certificate": "प्रमाणपत्र"
    }
}